<script>
import libraryCards from "@/views/EmotionLibrary/libraryCards";
import router from "@/router";
import {onMounted} from "vue";

export default {
  name: "EmotionLibraryList.vue",
  methods: {
    router() {
      return router
    }
  },
  components: {},
  setup() {
    const getEmotionImage = (name) => {
      return require("@/assets/images/emotion_library/" + name + ".svg")
    }

    onMounted(() => {
      let header = document.querySelector('.card-title');
      header.scrollIntoView({ behavior: "smooth", block: "center"});
    });

    return {
      libraryCards,
      getEmotionImage,
    }
  }
}
</script>

<template>
  <div class="view-container">
    <div class="card staff-table">
      <div class="card-header card-header-divider header_green">
        <div class="card-title">Библиотека эмоций</div>
      </div>
      <div class="card-body">
        <div class="description">
          <p>
            Здесь вы можете ознакомиться с каждой из 27 эмоций.
          </p>
          <p>
            Согласно одной из научных теорий, существует 8 базовых эмоций: злость, страх, радость, печаль, доверие, отвращение, удивление и интерес. У этих базовых эмоций есть оттенки: например, интерес при усилении переходит в ожидание, которое в свою очередь переходит в настороженность. И так для каждой базовой эмоции, что в общем дает нам 24 эмоциональных оттенка. Так же есть социально-обусловленные эмоции, которые составляют неотъемлемую часть нашей жизни, например, смущение, стыд и вина.
          </p>
          <p>
            Эти 27 эмоций можно изобразить в виде Эмоционального Термометра. Научной основой Эмоционального Термометра являются теории эмоций Р. Плутчика и К. Изарда.
          </p>
        </div>
        <div class="library_wrapper">
          <ul class="library_list">
            <li v-for="(value, key) in libraryCards" :key="key" class="library_card">
              <div>
                <img :src="getEmotionImage(key)" :alt="'Иконка Эмоции ' + value.title" class="emotion_image" @click="() => {router().push('/library/emotion/' + key)}">
                <p class="library_card_title">{{value.title}}</p>
              </div>
              <a class="emotion_info" @click="() => {router().push('/library/emotion/' + key)}">
                Узнать подробнее
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.header_green {
  font-size: 24px;
  font-weight: bold;
  color: #51bb50;
}

.description {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  text-align: justify;
}

.library_wrapper {
  margin-top: 20px;
}

.library_list {
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: 5px;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}

.library_card_title {
  margin-top: 10px;
  text-align: center;
  text-transform: uppercase;
}

.library_card {
  width: 30%;
  height: 350px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d5d5;

  @media (max-width: 768px) {
    width: 100%;
  }
}

.emotion_image {
  width: 150px;
  height: 250px;
}

.emotion_info {
  font-weight: 400;
  cursor: pointer;
}

.emotion_image {
  cursor: pointer;
}

.library_card:has(.emotion_image:hover),
.library_card:has(.emotion_info:hover) {
  border-color: #2CC185;
}

.card-title {
  scroll-snap-align: start;
}
</style>